import { Howl } from 'howler';
import { getApiServerBaseURL } from './http/getBaseURL';
import { API_ENDPOINTS } from './http/apiEndpoints';

export default class SoundManager {
  alarmSound = null;

  notificationSound = null;

  getAlarmSound() {
    if (!this.alarmSound) {
      const url = `${getApiServerBaseURL()}/${API_ENDPOINTS.ALARM_SOUND_URL}`;
      this.alarmSound = new Howl({ src: [url] });
    }

    return this.alarmSound;
  }

  getNotificationSound() {
    if (!this.notificationSound) {
      const url = `${getApiServerBaseURL()}/${API_ENDPOINTS.NOTIFICATION_SOUND_URL}`;
      this.notificationSound = new Howl({ src: [url] });
    }

    return this.notificationSound;
  }
}
